import React, { MouseEvent, KeyboardEvent } from 'react';
import {
  WrappedComponentProps,
  MessageDescriptor,
  injectIntl
} from '@kyruus/intl';
import { SectionNavTabs } from 'Src/shared/SectionNavTabs';

import messages from '../../lib/messages';

import {
  TrackingFunction,
  trackProfileNavClick
} from '../../lib/tracking-utils';

import { getTabControlId } from '../../lib/utils';

export interface NavOptionsItems {
  id: string;
  name: string;
  label: MessageDescriptor | string;
  ariaLabelledBy: string;
  rendered: boolean;
  href: string;
}

export interface ProviderNavigationProps extends WrappedComponentProps {
  navOptions: NavOptionsItems[];
  track: TrackingFunction;
}

interface OnActivateMetadata {
  name?: string;
}

const ProviderNavigation = injectIntl(
  ({
    navOptions,
    track,
    intl
  }: ProviderNavigationProps): React.ReactElement => {
    const getNavLabel = (label: MessageDescriptor | string) => {
      if (typeof label === 'string') {
        return label;
      }
      return intl.formatMessage(label);
    };
    const navigationTabs = navOptions
      .filter(({ rendered }) => rendered === true)
      .map((navOption) => ({
        ...navOption,
        label: getNavLabel(navOption.label)
      }));
    const onActivate = (
      _event: MouseEvent | KeyboardEvent,
      _id: string,
      metadata?: OnActivateMetadata
    ) => {
      if (metadata?.name) {
        trackProfileNavClick(track, metadata.name);
      }
    };

    return (
      <SectionNavTabs
        aria-label={intl.formatMessage(messages.profileNavAriaLabel)}
        id="profile-nav"
        tabs={navigationTabs}
        onActivate={onActivate}
        getTabControlId={getTabControlId}
      />
    );
  }
);

export default ProviderNavigation;
